import React, { useState, useEffect } from "react";
import "./TimeLineControllers.css";
import { reaction } from "mobx";
import ApplyAllWarnPopup from "../../../components/ApplyAllWarnPopup";
import { useSelector } from "react-redux";
import { trackAnalyticsEvent } from "../../../utils/analytics";

export default function TimeLineControllers({
  showSmallThumbs,
  smallThumbHandler,
  showTimeline,
  timlineHandler,
  refreshHandler,
  handleUnlockClick,
  resetHandler,
  selectedType,
  isResetting,
  store,
  applyAllAlreadyClicked,
  setWarnPopup,
  warnPopup,
  applyingToAll,
  source = "design"
}) {
  const [isBackgroundPresent, setIsBackgroundPresent] = useState(false);
  const { isLoading } = useSelector((state) => state.design);

  useEffect(() => {
    if (!store?.activePage) return;

    // Set up reaction to monitor background changes
    const disposer = reaction(
      () => ({
        children: store.activePage.children.slice(),
        pageId: store.activePage.id,
      }),
      ({ children }) => {
        // Check if background image exists
        const hasBackgroundImage = children.some(
          (child) => child.type === "image" && child.name === "background-image"
        );


        // If master page has background, enable for all pages
        if (store.activePage.id === "master" && hasBackgroundImage) {
          setIsBackgroundPresent(true);
          return;
        }

        // For other pages, check if master has background
        const masterPage = store.pages.find((page) => page.id === "master");
        if (masterPage) {
          const masterHasBackground = masterPage.children.some(
            (child) =>
              child.type === "image" && child.name === "background-image"
          );
          setIsBackgroundPresent(masterHasBackground || hasBackgroundImage);
        } else {
          setIsBackgroundPresent(hasBackgroundImage);
        }
      },
      { fireImmediately: true }
    );

    return () => {
      disposer();
    };
  }, [store?.activePage]);

  if (showTimeline) {
    return (
      <div className="lgTimeLine-controller-buttons">
        <span
          onClick={timlineHandler}
          className={showSmallThumbs ? "selected" : ""}
        >
          <img src={"/assets/images/list-pages-icn.svg"} alt="List Pages" />
        </span>
        <span
          onClick={timlineHandler}
          className={showTimeline ? "selected" : ""}
        >
          <img src={"/assets/images/all-pages-icn.svg"} alt="All Pages" />
        </span>
      </div>
    );
  }

  return (
    <>
      <div className="pages-controller-items">
        <div className="pages-controller-item">
          <div className="pages-controller-buttons">
            {selectedType && selectedType !== "a4" && selectedType !== "a3" && selectedType !== "a2" && selectedType !== "a1" && selectedType !== "custom" && (
              <>
                <button
                  onClick={() => {
                    trackAnalyticsEvent("design_apply_to_all_click", {
                      selected_type: selectedType,
                      source,
                    });
                    refreshHandler();
                  }}
                  className="apply-to-all"
                  disabled={applyingToAll || isLoading}
                >
                  <img
                    src={"/assets/images/refresh_page_icn.svg"}
                    alt="Refresh Icon"
                  />
                  {applyingToAll ? "Applying..." : "Apply to all"}
                </button>
                {warnPopup && !applyAllAlreadyClicked && (
                  <ApplyAllWarnPopup
                    type="applyall"
                    close={() => setWarnPopup(false)}
                  />
                )}
              </>
            )}

            <button
              onClick={() => {
                trackAnalyticsEvent("design_unlock_background_click", {
                  selected_type: selectedType,
                  source,
                });
                handleUnlockClick();
              }}
            >
              Unlock background
            </button>

            {source === "design" && <button onClick={() => {
              trackAnalyticsEvent("design_reset_all_canvases_click", {
                selected_type: selectedType,
                source,
              });
              resetHandler();
            }} disabled={isResetting}>
              {isResetting ? (
                <>
                  <span className="loader"></span>
                  Resetting...
                </>
              ) : (
                "Reset all canvaes"
              )}
            </button>}


          </div>
        </div>
      </div>
    </>
  );
}
